import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './UpcomingTournaments.module.scss'
import BackButton from '../../components/buttons/BackButton/BackButton'
import { TourSelection } from '../../components/TourSelection/TourSelection'
import { useSaveSelectedTournaments, useSelectedTours } from '../../hooks'
import { useAuthStatus } from '../../utils'

export const UpcomingTournaments = () => {
	const [selectedTourIds, setSelectedTourIds] = useState([])
	const navigate = useNavigate()
	const [auth] = useAuthStatus()

	const saveMutation = useSaveSelectedTournaments()
	const { data: previousSelectedTours } = useSelectedTours(auth.user?.id)
	console.log('previousSelectedTours: ', previousSelectedTours)

	const handleSave = async () => {
		try {
			await saveMutation.mutateAsync({
				tournamentIds: selectedTourIds,
				skipped: false,
			})
			alert('대회 선택이 저장되었습니다.')
			// navigate(-1) // 이전 페이지로 이동
		} catch (error) {
			console.error('대회 저장 실패:', error)
			alert('대회 저장에 실패했습니다. 다시 시도해주세요.')
		}
	}

	return (
		<div className={styles.tournamentWrapper}>
			<BackButton />
			<div className={styles.tournamentContent}>
				<div className={styles.tournamentTitleBox} style={{ marginBottom: '12px' }}>
					<h2 className={styles.tournamentTitle}>출전 예정 대회</h2>
					<span className={styles.explain}>
						대회를 선택하고 캐디에게 맞춤형 제안을 받아보세요
					</span>
				</div>

				{(!previousSelectedTours ||
					!previousSelectedTours.tours ||
					previousSelectedTours.tours.length === 0) && (
					<div className={styles.warningMessageContainer}>
						<div className={styles.warningMessage}>
							<div>
								<svg
									width="14"
									height="14"
									viewBox="0 0 14 14"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M0.5 7C0.5 3.41015 3.41015 0.5 7 0.5C10.5899 0.5 13.5 3.41015 13.5 7C13.5 10.5899 10.5899 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7ZM7 4.5C7.27614 4.5 7.5 4.72386 7.5 5V7.5C7.5 7.77614 7.27614 8 7 8C6.72386 8 6.5 7.77614 6.5 7.5V5C6.5 4.72386 6.72386 4.5 7 4.5ZM7 10C7.27614 10 7.5 9.77614 7.5 9.5C7.5 9.22386 7.27614 9 7 9C6.72386 9 6.5 9.22386 6.5 9.5C6.5 9.77614 6.72386 10 7 10Z"
										fill="#FF5D5D"
									/>
								</svg>
								출전 대회 미설정 상태에요. 대회를 선택해주세요.
							</div>
						</div>
					</div>
				)}

				<TourSelection
					TourCount={true}
					selectOnlyOne={false}
					upcomingOnly={true}
					onSelectedToursChange={(selectedIds) => {
						setSelectedTourIds(selectedIds)
					}}
					onNoToursAvailable={(noTours) => {
						console.log('대회 없음:', noTours)
					}}
					previousSelectedTours={previousSelectedTours || []}
				/>
				<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<button
						className={styles.nextButton}
						onClick={handleSave}
						disabled={saveMutation.isPending || selectedTourIds.length === 0}>
						{saveMutation.isPending ? '저장 중...' : '저장'}
					</button>
				</div>
			</div>
		</div>
	)
}
